import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { AssistantReducer } from './reducers/assistant'
import { SettingsReducer } from './reducers/settings'

const reducer = combineReducers({
  assistant: AssistantReducer,
  settings: SettingsReducer,
})

const persistedReducer = persistReducer({ key: 'root', storage }, reducer)

const _makeStore = () =>
  configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
    reducer: persistedReducer,
  })

let store: ReturnType<typeof _makeStore>

export const makeStore = () => {
  if (store) return store

  const newStore = _makeStore()
  store = newStore

  return newStore
}

export type RootState = ReturnType<ReturnType<typeof makeStore>['getState']>

export type AppDispatch = ReturnType<typeof makeStore>['dispatch']
